import React from "react"

const Footer = () => (
  <div className = { "footer" }>
    Giacomo Bruno { new Date().getFullYear() }
    <span>–</span>
    <a
      className = { "privacy" }
      href = { "https://www.iubenda.com/privacy-policy/87479330" }
      title = { "Privacy Policy" }
      target = { "_blank" }
    >
       Privacy Policy
    </a>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js